import React from "react";
import Certificate from "../Certificate";
import { useGlobalContext } from "../../context";
import Loading from "../Loading";
import Paginate from "./Paginate";

const CertificatesPage = () => {
  const { apiClient } = useGlobalContext();
  const [loading, setLoading] = React.useState(false);
  const [certificates, setCertificates] = React.useState([]);
  const [certificateCount, setCertificateCount] = React.useState(0);
  const [sort, setSort] = React.useState("createdAt:DESC");
  const [search, setSearch] = React.useState("");
  const [page, setPage] = React.useState(1);
  const searchRef = React.useRef(null);

  async function getCertificates() {
    try {
      setLoading(true);
      const res = await apiClient.get(
        `/certificates?_sort=${sort}&_q=${search}&_start=${
          (page - 1) * 10
        }&_limit=10`
      );
      if (res.status >= 200 && res.status < 300) {
        setCertificates(res.data);
      }
    } catch (error) {
      alert(error);
      console.error(error);
    } finally {
      setLoading(false);
    }
  }
  async function countCertificates() {
    try {
      const res = await apiClient.get(`/certificates/count?_q=${search}`);
      setCertificateCount(res.data || 0);
    } catch (error) {
      alert(error);
    }
  }
  async function removeCertificates(id) {
    if (window.confirm("Do you really want to delete this certificate?")) {
      try {
        setLoading(true);
        await apiClient.delete(`/certificates/${id}`);
        setCertificates(certificates.filter((e) => e.id !== id));
      } catch (error) {
        alert(error);
      } finally {
        setLoading(false);
      }
    }
  }
  React.useEffect(() => {
    setPage(1);
    countCertificates();
  }, [search]);
  React.useEffect(() => {
    getCertificates();
  }, [sort, search, page]);

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <h4 className="text-muted m-0">Certificates ({certificateCount})</h4>

        <div className="ms-auto me-2">
          <div className="input-group input-group-sm">
            <label
              htmlFor="sort-select"
              className="input-group-text border-end-0"
            >
              <small>Sort by</small>
            </label>
            <select
              name="sort-select"
              id="sort-select"
              className="form-select form-select-sm ms-auto"
              value={sort}
              onChange={(e) => setSort(e.target.value)}
            >
              <option value="createdAt:DESC">Date</option>
              <option value="name">Student</option>
              <option value="exam">Exam</option>
            </select>
          </div>
        </div>
        <div>
          <div className="input-group">
            <input
              type="search"
              name="search"
              id="search-input"
              className="form-control form-control-sm"
              placeholder="Search here..."
              ref={searchRef}
              onChange={(e) => {
                if (!e.target.value) {
                  setSearch("");
                }
              }}
            />
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => setSearch(searchRef.current.value)}
            >
              Search
            </button>
          </div>
        </div>
      </div>
      {loading ? (
        <Loading />
      ) : certificates.length === 0 ? (
        <h5 className="mb-0">No certificates found.</h5>
      ) : (
        certificates.map((c, i) => (
          <div
            className="d-flex align-items-center bg-light rounded p-2 my-1"
            key={c.id}
          >
            <div className="me-auto ps-2">
              <h6 className="m-0">{c.name}</h6>
              <p className="m-0 form-text">{c.exam}</p>
            </div>

            <Certificate
              key={i}
              certificate={c}
              admin={true}
              removeCertificate={removeCertificates}
            />
          </div>
        ))
      )}
      <Paginate total={certificateCount} setPage={setPage} page={page} />
    </div>
  );
};

export default CertificatesPage;
